import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Division } from "../models/division"; 
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class DivisionService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'division/id/d32a6cc9-353b-4e23-90fb-3c410cd6fd7e/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }

  getAllDivisions(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<Division>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllDivisions?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  getAllDivisionbyClusterId(Cluster_Id?: string): Observable<Array<Division>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllDivisionbyClusterId/' + (Cluster_Id ? Cluster_Id : '')  ).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  viewDivision(DivisionID?: string): Observable<Array<Division>> {
    return this.httpService.get(this.apiEndpoint + 'viewDivision/' + (DivisionID ? DivisionID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  saveDivision(locations: Division): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'saveDivision/', locations).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  deleteDivision(DivisionID?: string): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deleteDivision/' + (DivisionID ? DivisionID : '00000000-0000-0000-0000-000000000000'), DivisionID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkDuplication(DivisionId?: string,Code?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?&DivisionId=' + (DivisionId ? DivisionId : '00000000-0000-0000-0000-000000000000')+'&Code=' + (Code ?Code : '')).pipe(map((result: any) => {
        return result; 
    }));
  }
  checkEmail(Emailid?: string,DivisionId?: string): Observable<any> { 
    return this.httpService.get(this.apiEndpoint + 'checkEmail?Emailid=' + (Emailid ? Emailid : '')+ '&DivisionId=' + (DivisionId ? DivisionId : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        return result; 
    }));
  }
}
